import React, { useState, useEffect } from "react";

const Carousel = ({ images, interval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            handleNext();
        }, interval);

        return () => clearInterval(timer);
    }, [currentIndex]);

    const handleNext = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setTimeout(() => setIsAnimating(false), 700);
    };

    const handlePrev = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
        setTimeout(() => setIsAnimating(false), 700);
    };

    const goToSlide = (index) => {
        if (isAnimating || index === currentIndex) return;
        setIsAnimating(true);
        setCurrentIndex(index);
        setTimeout(() => setIsAnimating(false), 700);
    };

    return (
        <div className="relative w-full h-[400px] overflow-hidden rounded-3xl shadow-lg bg-gray-100">
            {/* Slider Container */}
            <div
                className="absolute inset-0 flex transition-transform duration-700 ease-in-out rounded-3xl"
                style={{
                    transform: `translateX(-${currentIndex * 100}%)`,
                }}
            >
                {images.map((image, index) => (
                    <div key={index} className="relative flex-shrink-0 w-full h-full">
                        {/* Blurred Background */}
                        <div
                            className="absolute inset-0 blur-2xl scale-150 z-0 rounded-3xl"
                            style={{
                                backgroundImage: `url(${image.imageUrl})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                filter: "blur(10px)",
                            }}
                        ></div>

                        {/* Main Image */}
                        <img
                            src={image.imageUrl}
                            alt={image.altText}
                            className="relative z-10 w-full h-full object-contain rounded-3xl"
                        />
                    </div>
                ))}
            </div>

            {/* Navigation Buttons */}
            <button
                className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full z-20 focus:outline-none"
                onClick={handlePrev}
            >
                ❮
            </button>
            <button
                className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full z-20 focus:outline-none"
                onClick={handleNext}
            >
                ❯
            </button>

            {/* Indicators */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
                {images.map((_, index) => (
                    <button
                        key={index}
                        className={`w-3 h-3 rounded-full ${
                            currentIndex === index ? "bg-white" : "bg-gray-400"
                        }`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    ></button>
                ))}
            </div>
        </div>
    );
};

export default Carousel;
